import { Dialog } from "@progress/kendo-react-dialogs";
import React from "react";
import "./staff_referral.css";
import { TextBox } from "@progress/kendo-react-inputs";
export const Search = (props) => {

  return (
    <Dialog width={395} height={"100%"} className="staff_referral_filter_dialog">
      <div className="staff_referral_filter_main_box">
        <div style={{ position: "relative" }}>
          <div
            className="staff_referral_filter_cross_icon"
            onClick={() => props.setShowFilter(false)}
          >
            <span class="k-icon k-font-icon k-i-close k-icon-xl" />
          </div>
        </div>
        <div className="staff_referral_filter_header_box">
          <div className="staff_referral_filter_header_title">Search</div>
        </div>
        <div className="staff_referral_filter_detail_main_box">

          <div className="staff_referral_filter_detail_date_box">
            <div className="staff_referral_filter_detail_title">By Name of Referee as Per NRIC</div>
            <div className="staff_referral_filter_radio_button_main_box">
              <TextBox
                className="campaigns_create_item_main_box_field"
                value={props.searchValue.name}
                onChange={(e) =>
                  props.setSearchValue({
                    ...props.searchValue,
                    name: e.target.value,
                  })
                }
              />
            </div>

          </div>

          <div className="staff_referral_filter_detail_date_box">
            <div className="staff_referral_filter_detail_title">By Singapore Contact Number</div>
            <div className="staff_referral_filter_radio_button_main_box">
              <TextBox
                className="campaigns_create_item_main_box_field"
                value={props.searchValue.contact_no}
                type="number"
                onChange={(e) =>
                  props.setSearchValue({
                    ...props.searchValue,
                    contact_no: e.target.value,
                  })
                }
              />
            </div>

          </div>

          <div className="staff_referral_filter_detail_date_box">
            <div className="staff_referral_filter_detail_title">By Submitter's Name</div>
            <div className="staff_referral_filter_radio_button_main_box">
              <TextBox
                className="campaigns_create_item_main_box_field"
                value={props.searchValue.submitter_name}
                onChange={(e) =>
                  props.setSearchValue({
                    ...props.searchValue,
                    submitter_name: e.target.value,
                  })
                }
              />
            </div>

          </div>


        </div>
        <div className="staff_referral_filter_footer_main_box">
          <div
            className="staff_referral_filter_footer_cancel"
            onClick={() => props.setShowSearch(false)}
          >
            Cancel
          </div>
          <div
            className="staff_referral_filter_footer_submit"
            onClick={props.SearchAction}
          >
            Submit
          </div>
        </div>
      </div>
    </Dialog>
  );
};
